import React, { useEffect, useState } from "react";
import styles from "./SubscriptionPopup.module.css";
import { readOrderHistory } from "../../Services/pgi";
import { connect } from "react-redux";
import { getFormattedDate } from "../../Values/utils";

interface SubscriptionPopupProps {
    user?: any,
    totalLicences:any,
    activeTill:any,
    data:any,

}

const SubscriptionPopup: React.FC<SubscriptionPopupProps> = ({user,totalLicences,activeTill,data}) => {
    
    return (
        <>
            <div className={styles.SubscriptionTitle}>ReadPRO Subscription details</div>

            <div className={styles.SubscriptionEmailOrder}>
                <div className={styles.SubscriptionEmailOrderItem}>
                    OID : <span className="TextBold">{user.user_oid}</span>
                </div>
                <div className={styles.SubscriptionEmailOrderItem}>
                    Email ID : <span className="TextBold">{user.user_email}</span>
                </div>
            </div>

            <div className={styles.SubscriptionLicences}>
                <div className={styles.SubscriptionLicencesItem}>
                    <div className={styles.SubscriptionLicencesItemTitle}>Total Licences</div>
                    <div className={styles.SubscriptionLicencesItemValue}>{totalLicences}</div>
                </div>
                <div className={styles.SubscriptionLicencesItem}>
                    <div className={styles.SubscriptionLicencesItemTitle}>Active till</div>
                    <div className={styles.SubscriptionLicencesItemValue}>{getFormattedDate(activeTill)}</div>
                </div>
            </div>

            <div className={styles.SubscriptionTableTitle}>Subscription History</div>
            

            <div className={styles.SubscriptionTable}>
                <div className={`${styles.SubscriptionTableRow} ${styles.Head}`}>
                    <div className={styles.SubscriptionTableCol}>
                        <div className={styles.SubscriptionHeadText}>Trans. ID</div>
                    </div>

                    <div className={styles.SubscriptionTableCol}>
                        <div className={styles.SubscriptionHeadText}>Licences</div>
                    </div>

                    <div className={styles.SubscriptionTableCol}>
                        <div className={styles.SubscriptionHeadText}>Subscription Date</div>
                    </div>

                    <div className={styles.SubscriptionTableCol}>
                        <div className={styles.SubscriptionHeadText}>Expiry Date</div>
                    </div>
                </div>

                {data.length === 0?<div className="TextBold" style={{margin:10}}>No Licenses Purchase</div>:<div className={styles.SubscriptionTableScroll}>
                    {
                        data.map((data: any, index: number) => (
                            // console.log("data mapp",data)
                        <div className={styles.SubscriptionTableRow}>
                            <div className={styles.SubscriptionTableCol}>{data.transactionId}</div>
                            <div className={styles.SubscriptionTableCol}>
                                <span className="TextBold">{data.packageCredit}</span> Licenses
                            </div>
                            <div className={styles.SubscriptionTableCol}>{getFormattedDate(data.orderDate)}</div>
                            <div className={styles.SubscriptionTableCol}>{getFormattedDate(data.orderEndDate)}</div>
                        </div>
                        ))
                    }
                </div>}
            </div>
        </>   
    )
}

const mapStateToProps = (state: any) => {
    return {
        user: state.user.data,
    };
};

export default connect(mapStateToProps)(SubscriptionPopup);
